
      <nz-float-button-group
        [nzIcon]="icon"
        nzType="primary"
        nzTip="Debugar Fluxo"
        nzTrigger="click"
        (nzOnOpenChange)="openChange($event)">

        <nz-float-button [nzIcon]="import" nz-tooltip nzTooltipTitle="{{'workflow.import'|translateTA}}" (click)="importData($event)" [ngClass]="{'disabled-float-btn':selectedVersion?.status!='DRAFT'}"></nz-float-button>
        <nz-float-button [nzIcon]="export" nz-tooltip nzTooltipTitle="{{'workflow.export'|translateTA}}" (click)="exportData($event)"></nz-float-button>
        <nz-float-button [nzIcon]="edit" (click)="editStep($event)" nz-tooltip nzTooltipTitle="{{'workflow.edit.step'|translateTA}}" [ngClass]="{'disabled-float-btn':selectedVersion?.status!='DRAFT'}"></nz-float-button>
        <nz-float-button [nzIcon]="log" (click)="logFlow($event)" nz-tooltip nzTooltipTitle="{{'workflow.log'|translateTA}}" ></nz-float-button>
        <nz-float-button [nzIcon]="variable" (click)="openVariables()" nz-tooltip nzTooltipTitle="{{'workflow.variable'|translateTA}}" ></nz-float-button>
        <nz-float-button [nzIcon]="copy" ngClass="copy-bg" nz-tooltip nzTooltipTitle="{{'copy'|translateTA}}" (click)="copyFlow($event)" [ngClass]="{'disabled-float-btn':selectedVersion?.status!='ACTIVE'}"></nz-float-button>
        <nz-float-button [nzIcon]="publish" ngClass="publish-bg" nz-tooltip nzTooltipTitle="{{'deploy'|translateTA}}" (click)="deploy()" [ngClass]="{'disabled-float-btn':selectedVersion?.status!='DRAFT'}"  ></nz-float-button>
        <nz-float-button [nzIcon]="bug" nz-tooltip nzTooltipTitle="{{(!debug?'debug':'stopdebug')|translateTA}}" (click)="dodebug($event)" [ngClass]="{'disabled-float-btn':selectedVersion?.status=='ACTIVE'}"  ></nz-float-button>
        
      </nz-float-button-group>
      
        <ng-template #publish>
            <mat-icon class="publish-icon" [ngClass]="{'publish-icon':selectedVersion?.status=='DRAFT','disable-icon':selectedVersion?.status!='DRAFT'}">publish</mat-icon>
        </ng-template>
        <ng-template #log>
            <nz-icon nzType="sync" nzTheme="outline" class="log-icon"></nz-icon>
        </ng-template>

        <ng-template #edit>
            <nz-icon nzType="edit" nzTheme="twotone" ></nz-icon>
        </ng-template>

         <ng-template #icon>
            <nz-icon nzType="setting" nzTheme="twotone"></nz-icon>
        </ng-template>

         <ng-template #import>
            <nz-icon nzType="import" nzTheme="outline" class="log-icon"></nz-icon>
        </ng-template>

         <ng-template #export>
            <nz-icon nzType="export" nzTheme="outline" class="log-icon"></nz-icon>
        </ng-template>

        <ng-template #bug>
            <nz-icon nzType="bug" nzTheme="twotone" *ngIf="!debug"></nz-icon>
            <nz-icon nzType="stop" nzTheme="twotone" *ngIf="debug"  [nzTwotoneColor]="'#eb2f96'" ></nz-icon>
        </ng-template>


        <!-- <ng-template #play>
            <nz-icon nzType="play-circle" nzTheme="twotone" [nzTwotoneColor]="!debug?'#52c41a':'#888'"></nz-icon>
        </ng-template> -->

        <ng-template #copy>
            <nz-icon nzType="copy" nzTheme="twotone" [nzTwotoneColor]="selectedVersion?.status=='ACTIVE'?'#52c41a':'#888'"></nz-icon>
        </ng-template>

        <!-- <ng-template #stop>
            <nz-icon nzType="stop" nzTheme="twotone" [nzTwotoneColor]="debug?'#eb2f96':'#888'" ></nz-icon>
        </ng-template> -->

         <ng-template #variable>
            <mat-icon class="variable-icon" >alternate_email</mat-icon>
        </ng-template>
        
